import { motion } from "framer-motion";
import { ShieldCheck, BadgeCheck, Clock, MapPin, Receipt } from "lucide-react";
import { GUARANTEES } from "@/lib/siteData";

const ICONS = [BadgeCheck, ShieldCheck, Clock, MapPin, Receipt];

export const Guarantees = () => {
  return (
    <section data-testid="guarantees" className="py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {GUARANTEES.map((g, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={g}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`guarantee-${i}`}
                className="flex items-center gap-3 rounded-2xl border-2 border-black bg-[#FEBE10] px-5 py-5"
              >
                <Icon className="h-5 w-5 shrink-0 text-[#111111]" />
                <span className="text-sm font-semibold text-[#111111]">{g}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
